import FollowUsList from './FollowUsList';
import BottomBarGrid from './BottomBarGrid';
import type { FollowUsItem, SiteUrl } from '../types';

interface BottomBarLogoMenuProps {
    followUs: FollowUsItem[];
    bottomBarGridItems: SiteUrl[];
}

function BottomBarLogoMenu({ followUs, bottomBarGridItems }: BottomBarLogoMenuProps) {
    return (
        <div className="bottomBarLogoMenu">
            <FollowUsList followUs={followUs} />
            <BottomBarGrid bottomBarGridItems={bottomBarGridItems} />
        </div>
    );
}

export default BottomBarLogoMenu;
